import app from 'flarum/forum/app';
/**
 * Translate a key with a hard-coded fallback for the case where the locale
 * file is missing the entry.
 */
export const trans = (key, fallback) => {
  const out = app.translator.trans(key);
  if (out === key) return fallback;
  return out;
};

/**
 * Read a forum-attribute boolean. The PHP side uses `boolval` in
 * `serializeToForum`, so values arrive as true/false/null.
 */
export const settingEnabled = function (key, defaultValue) {
  if (defaultValue === void 0) {
    defaultValue = false;
  }
  const val = app.forum.attribute(key);
  if (val === null || val === undefined) return defaultValue;
  return !!val;
};